import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = StyleSheet.create({
    containerGeneral: {
        flex: 1,
        backgroundColor: 'white',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
    },
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    inputContainer: {
        flexDirection: 'row',
        width: width - 24,
        height: 40,
        borderWidth: 1,
        borderRadius: 10,
        borderColor: theme.colors.lightGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 12,
        marginHorizontal: 12,
    },
    input: {
        flex: 1,
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
    },
    inputdrop: {
        height: 40,
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 0,
        paddingHorizontal: 12,
        marginHorizontal: 12,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    dropdown: {
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
        marginTop: 0,
    },
    dropdownOptions: {
        color: theme.colors.textPrimary,
    },
    dropdownInput: {
        color: theme.colors.mediumGray,
    },
    dropdownInputSelected: {
        color: theme.colors.textPrimary,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginTop: 12,
        marginBottom: 4,
        textAlign: 'left',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    subtitle: {
        fontSize: 16,
        fontWeight: 'normal',
        textAlign: 'left',
        color: theme.colors.textPrimary,
        marginBottom: 24,
    },
    note: {
        fontSize: 14,
        fontWeight: 'normal',
        textAlign: 'left',
        color: theme.colors.textSecondary,
        marginHorizontal: 12,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: width - 24,
        marginHorizontal: 12,
        paddingVertical: 5,
    },
    mainButton: {
        width: '100%',
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        padding: 0,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 5,
    },
    mainButtonText: {
        fontSize: 15,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
})

export default styles
